import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Loading from '../ui/Loading';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, applicationStatus, isCheckingStatus } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // Show loading spinner while checking authentication or status
  if (isLoading || isCheckingStatus) {
    return (
      <div className="auth-loading-container">
        <Loading />
        <p>{isLoading ? 'Checking authentication...' : 'Checking application status...'}</p>
      </div>
    );
  }

  // If not authenticated, redirect to login with the intended destination
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If authenticated but status is submitted, redirect to application submitted page
  if (applicationStatus === 'submitted') {
    // Only redirect if we're not already on the application-submitted page
    const currentPath = location.pathname;
    if (currentPath !== '/application-submitted') {
      return <Navigate to="/application-submitted" replace />;
    }
  }

  // If status check failed or status is unknown, redirect to business type (default flow)
  if (applicationStatus === 'error' || applicationStatus === null) {
    // Only redirect if we're not already on a valid page
    const currentPath = location.pathname;
    const validPaths = ['/business-type', '/representative-details', '/shop-details', '/review-submit'];
    if (!validPaths.includes(currentPath)) {
      return <Navigate to="/business-type" replace />;
    }
  }

  // If authenticated and status is okay, render the protected component
  return children;
};

export default ProtectedRoute;
